export enum MongoSortDirection {
  ASCENDING = 1,
  DESCENDING = -1,
}
